import axios from 'axios'

// axios 配置
axios.defaults.timeout = 5000
//axios.defaults.baseURL = "http://192.168.1.15:22280/v1/api/"
axios.defaults.baseURL = "/v1/api/"

// http response 拦截器
axios.interceptors.response.use(
	response => {
    return response;
	},
	error => {
    return Promise.reject(error)
  },
)

export default axios